import React from "react";
import { useSelector } from 'react-redux';
import NotificationItem from "./notification_item";

/**
 * Notification Panel Component
 * 
 * @returns { JSX.Element }
 */
export function NotificationPanel(props) {

    const notifications = useSelector((store) => store.notifications.notifications);
    const unread_notifications = notifications.filter(notification => !notification.read);
    
    return (
        <>
            <a className="dropdown-toggle count-info" data-toggle="dropdown" href="#">
                <i className="fa fa-envelope fa-xl"></i>  
                { !!unread_notifications.length &&
                    <span className="label label-danger">{ unread_notifications?.length }</span>
                }
            </a>
            <div className="dropdown-menu dropdown-messages dropdown-menu-right">
                <div className="notification-dropdown max-height-350 overflow">

                    { !!unread_notifications.length ? (
                        <>
                            { unread_notifications.map((notification, index) => 
                                <NotificationItem
                                    key={`${index}-${notification.subject}`}
                                    lastIndex={index === unread_notifications.length - 1}
                                    { ...notification }
                                />
                            )}
                        </>
                    ) : (
                        <p className="text-center mt-3">No Unread Notifications</p>
                    )}

                </div>
                
                <div className="dropdown-divider" />
                
                { notifications.length
                    ?   <div className="text-center" role="button" onClick={() => props.setShowNotificationsModal(true)}>
                            <div className="dropdown-item p-2">
                                <i className="fa fa-envelope"></i> <strong>All Notifications</strong>
                            </div>
                        </div>
                    :   <h2 className="text-center">No Notifications</h2>
                }
            </div>
        </>
    );
}